import { Fragment } from 'react';
import { Col, Form, FormGroup, Label, Input, Row } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Btn } from '../../../AbstractElements';
import { setField } from '../../../Features/Learning/CategoryProgram/addCategoryProgramSlice';

const CategoryProgramForm = () => {
  const dispatch = useDispatch()
  const data = useSelector(state => state.addCategoryProgram)

  const handleChanges = (e) => {
    const { name, value } = e.target;
    dispatch(setField({ field: name, value: value }));
  }

  const handleAddPoint = () => {
    const updatedPoints = [...data?.children];
    updatedPoints.push({ name: '', parent_id: 1 });
    dispatch(setField({ field: 'children', value: updatedPoints }));
  };

  const handleRemovePoint = (index) => {
    const updatedPoints = [...data?.children];
    updatedPoints.splice(index, 1);
    dispatch(setField({ field: 'children', value: updatedPoints }));
  };

  const handleChangePoint = (e, index) => {
    const { value } = e.target;
    const newPointTemp = [...data?.children];
    newPointTemp[index] = { ...newPointTemp[index], [e.target.name]: value };

    dispatch(setField({ field: 'children', value: newPointTemp }));
  };

  return (
    <Fragment>
      <Form className="row needs-validation">
        <Col sm="12">
          <FormGroup className='mb-3'>
            <Label for="validationtitle" style={{ fontWeight: 'bold' }}>{'Nama Kategori'}:</Label>
            <Input className="form-control" id="validationtitle" type="text" name="name" placeholder="Nama Kategori" required=""
              value={data?.name}
              onChange={handleChanges} />
            <div className="valid-feedback">{'Looks good!'}</div>
          </FormGroup>
          <FormGroup className='mb-3'>
            <Label for="validationtitle" style={{ fontWeight: 'bold' }}>{'Nama Slug Kategori'}:</Label>
            <Input className="form-control" id="validationtitle" type="text" name="slug" placeholder="Nama Slug Kategori" required=""
              value={data?.slug}
              onChange={handleChanges} />
            <div className="valid-feedback">{'Looks good!'}</div>
          </FormGroup>
          {data?.children?.map((point, index) => (
            <>
              <FormGroup key={index} className='mb-3'>
                <Row>
                  <Col>
                    <Label for="validationPoint" style={{ fontWeight: 'bold' }}>Sub Kategori {index + 1}:
                      {index > 0 && (
                        <Btn
                          attrBtn={{
                            color: 'link',
                            outline: true,
                            className: 'p-1',
                            onClick: () => handleRemovePoint(index)
                          }}
                        >
                          <i className="fa fa-close mx-auto text-danger fa-2x"></i>
                        </Btn>

                      )}
                    </Label>
                    <Input className="form-control" id="validationPoint" type="text" name="name" placeholder="Masukkan sub kategori..." required=""
                      value={data?.children?.[index]?.name || ''}
                      onChange={(e) => handleChangePoint(e, index)} />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup key={index} className='mb-3'>
                <Row>
                  <Col>
                    <Label for="validationPoint" style={{ fontWeight: 'bold' }}>Sub Slug Kategori {index + 1}:
                      {index > 0 && (
                        <Btn
                          attrBtn={{
                            color: 'link',
                            outline: true,
                            className: 'p-1',
                            onClick: () => handleRemovePoint(index)
                          }}
                        >
                          <i className="fa fa-close mx-auto text-danger fa-2x"></i>
                        </Btn>

                      )}
                    </Label>
                    <Input className="form-control" id="validationPoint" type="text" name="slug" placeholder="Masukkan sub slug kategori..." required=""
                      value={data?.children?.[index]?.slug || ''}
                      onChange={(e) => handleChangePoint(e, index)} />
                  </Col>
                </Row>
              </FormGroup>
            </>
          ))}
          <FormGroup className='mb-3'>
            <Btn
              attrBtn={{
                color: 'link',
                outline: true,
                className: 'p-1',
                onClick: () => handleAddPoint()
              }}
            >
              <i className="fa fa-plus-circle mx-auto fa-2x" style={{ color: '#3C6F7D' }}></i>
            </Btn>
          </FormGroup>
        </Col>
      </Form>
    </Fragment>
  );
};
export default CategoryProgramForm;